<template>
  <div>
    <h3 class="ts-text-xs ts-uppercase ts-text-blue-700">{{ $t('employeeProfile.employment') }}</h3>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-6 ts-space-y-4">
          <div class="row">
            <label
              class="required col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.hireDate') }}</label>
            <div class="col-md-7">
              <a-date-picker
                v-model="model.employment_date"
                :allowClear="false"
               	format="DD-MM-YYYY"
								valueFormat="DD-MM-YYYY" 
                class="ts-w-full"
              ></a-date-picker>
              <div
                class="validate"
                v-if="errors.has('employment_date')"
              >{{ errors.first('employment_date') }}</div>
            </div>
          </div>

          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.department') }}</label>
            <div class="col-md-7">
              <a-select
                v-model.number="model.department_id"
                :options="departments"
                showSearch
                :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
                class="ts-w-full"
              ></a-select>
              <div
                class="validate"
                v-if="errors.has('department_id')"
              >{{ errors.first('department_id') }}</div>
            </div>
          </div>

          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.position') }}</label>
            <div class="col-md-7">
              <a-select
                showSearch
                v-model.number="model.position_id"
                :options="positions"
                :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
                class="ts-w-full"
              ></a-select>
              <div
                class="validate"
                v-if="errors.has('position_id')"
              >{{ errors.first('position_id') }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-6 ts-space-y-4">
          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.probationEndDate') }}</label>
            <div class="col-md-7">
              <a-date-picker 
								v-model="model.probation_end_date"
								format="DD-MM-YYYY"
								valueFormat="DD-MM-YYYY"  
								class="ts-w-full"
							></a-date-picker>
              <div
                class="validate"
                v-if="errors.has('probation_end_date')"
              >{{ errors.first('probation_end_date') }}</div>
            </div>
          </div>
          <div class="row">
            <label
              class="required col-md-4 form-col-label control-label"
            >{{ $t('employeeProfile.status') }}</label>
            <div class="col-md-7">
              <a-select 
								v-model="model.status_id" 
								class="ts-w-full" 
								:options="status_lists"
                showSearch
                :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
								@change="() => model.status_effective_date = null"
							></a-select>
              <div
                class="validate"
                v-if="errors.has('status_id')"
              >{{ errors.first('status_id') }}</div>
            </div>
          </div>
          <div class="row">
            <label
              class="col-md-4 form-col-label control-label"
							:class="{ 'required': model.status_id !== 1 }"
            >{{ $t('employeeProfile.statusEffectiveDate') }}</label>
            <div class="col-md-7">
              <a-date-picker 
								v-model="model.status_effective_date"
								format="DD-MM-YYYY"
								valueFormat="DD-MM-YYYY" 
								class="ts-w-full"
								:disabled=" model.status_id == 1"
							></a-date-picker>
              <div
                class="validate"
                v-if="errors.has('status_effective_date')"
              >{{ errors.first('status_effective_date') }}</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'employment',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  computed: {
    status_lists() {
      return [
        { value: 1, label: 'Active' },
        { value: 2, label: 'Resigned' },
        { value: 3, label: 'Terminated' }
      ]
		},
		positions(){
			return this.$store.state.employee.profile.positionList.map(el => ({
				value: el.position_id,
				label: el.position_name_en
			}))
		},
		departments(){
			return this.$store.state.employee.profile.departmentList.map(el => ({
				value: el.department_id,
				label: el.department_name_en
			}))
		}
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>